"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bookingDataRequested = bookingDataRequested;
exports.bookingDataReceived = bookingDataReceived;
exports.linkedBookingsDataReceived = linkedBookingsDataReceived;
exports.linkedBookingCustomersDataReceived = linkedBookingCustomersDataReceived;
exports.bookingDataRequestFailed = bookingDataRequestFailed;
exports.setCountryId = setCountryId;
var BOOKING_DATA_REQUESTED = exports.BOOKING_DATA_REQUESTED = "BOOKING_DATA_REQUESTED";

function bookingDataRequested() {
    return {
        type: BOOKING_DATA_REQUESTED
    };
}

var BOOKING_DATA_RECEIVED = exports.BOOKING_DATA_RECEIVED = "BOOKING_DATA_RECEIVED";

function bookingDataReceived(bookingData) {
    return {
        type: BOOKING_DATA_RECEIVED,
        bookingData: bookingData
    };
}

var LINKED_BOOKINGS_DATA_RECEIVED = exports.LINKED_BOOKINGS_DATA_RECEIVED = "LINKED_BOOKINGS_DATA_RECEIVED";

function linkedBookingsDataReceived(linkedBookingsData) {
    return {
        type: LINKED_BOOKINGS_DATA_RECEIVED,
        linkedBookingsData: linkedBookingsData
    };
}

var LINKED_BOOKINGS_CUSTOMERS_DATA_RECEIVED = exports.LINKED_BOOKINGS_CUSTOMERS_DATA_RECEIVED = "LINKED_BOOKINGS_CUSTOMERS_DATA_RECEIVED";

function linkedBookingCustomersDataReceived(linkedBookingsCustomersData) {
    return {
        type: LINKED_BOOKINGS_CUSTOMERS_DATA_RECEIVED,
        linkedBookingsCustomersData: linkedBookingsCustomersData
    };
}

var BOOKING_DATA_REQUEST_FAILED = exports.BOOKING_DATA_REQUEST_FAILED = "BOOKING_DATA_REQUEST_FAILED";

function bookingDataRequestFailed(error) {
    return {
        type: BOOKING_DATA_REQUEST_FAILED,
        error: error
    };
}

var COUNTRY_ID_SET = exports.COUNTRY_ID_SET = "COUNTRY_ID_SET";
// Set country state actions
function setCountryId(countryId) {
    return {
        type: COUNTRY_ID_SET,
        countryId: countryId
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/bookingDataActions.js
// module id = 112
// module chunks = 0